<template>
  <transition name="fade">
    <div class="mask" v-if="options.showLoadingModal">
      <nav
        class="right-wrapper"
        v-if="options.isShowRightWrapper"
        v-clickOutside="closeRightWrapper"
      >
        <img src="~img/closeMenu@2x.png" alt="close menu" class="close-menu" @click="closeMenu" />
        <button role="button" class="lounge-btn" @click="handleLounge">
          {{ i18n.t('lounge') }}
        </button>
        <button role="button" class="lounge-btn" @click="handleBenefits">
          {{ i18n.t('benefits') }}
        </button>
        <mobile-menu-drop-down-list
          :listData="engDropDownList"
          @listItemClick="languagechange"
          :current-select="languageTitle"
        >
          <template v-slot:itemDesc="item">{{ item.item.label }}</template>
        </mobile-menu-drop-down-list>
        <button v-if="!isLogin" role="button" class="login-btn" @click="loginModalShow">
          {{ i18n.t('login') }}
        </button>
        <button v-if="!isLogin" role="button" class="sign-up" @click="handleSignup">
          {{ i18n.t('sign-up') }}
        </button>
        <mobile-menu-drop-down-list
          :current-select="`${userInfo.firstName} ${userInfo.lastName}`"
          :listData="userDropDownList"
          :header-img="headerImg"
          :img-style="imgStyle"
          :ulMargin="ulMargin"
          :itemImgStyle="itemImgStyle"
          :li-item-img-style="liItemImgStyle"
          @listItemClick="handleUserDropDownList"
          v-if="isLogin"
        >
          <template v-slot:itemDesc="item">{{ i18n.t(item.item.label) }}</template>
        </mobile-menu-drop-down-list>
        <div v-if="isLogin" role="button" class="logout" @click.stop="logout">
          <img src="@/components/LeftAccount/images/icon-logout.svg" alt="" />
          <span>{{ i18n.t('mbs-select-out') }}</span>
        </div>
      </nav>
    </div>
  </transition>
</template>

<script>
  import dropdown from '@/components/BaseUi/Dropdown';
  import i18n from '@/i18n/index';
  import store from '@/store';
  import router from '@/router';
  import MobileMenuDropDownList from '@/components/BaseUi/MobileMenuDropDownList';
  import { clickOutside } from '@/utils/directive.js';
  import { updateQueryString } from '@/utils';

  export default {
    components: {
      dropdown,
      MobileMenuDropDownList,
    },
    directives: { clickOutside },
    // props: {
    //   options: {
    //     type: Object,
    //     default: () => {
    //       return {
    //         showLoadingModal: false,
    //         isShowRightWrapper: false,
    //       };
    //     },
    //   },
    // },
    data() {
      return {
        i18n,
        fontStyle: {
          color: '#C29D5C',
          fontWeight: '600',
        },
        searchLish: [],
        headerImg: require('@/components/LeftAccount/images/my-account.png'),
        imgStyle: {
          width: '28px',
          height: '28px',
          paddingRight: '9px',
        },

        itemImgStyle: {
          width: '20px',
          height: '20px',
          backgroundSize: '20px 20px',
          marginRight: '11px',
        },
        liItemImgStyle: {
          padding: '0px',
        },
        ulMargin: {
          marginTop: '17px',
        },
        options: {
          showLoadingModal: false,
          isShowRightWrapper: false,
        },
      };
    },
    mounted() {
      console.log(this.userDropDownList);
    },
    computed: {
      // 获取语种
      languageTitle() {
        const lang = localStorage.getItem('lang');
        if (store.state.globalLangList.length) {
          const findItem = store.state.globalLangList.find(item => item.param === lang);
          return findItem.shortName;
        }
      },
      // 下拉框语种
      engDropDownList() {
        const langArr = [];
        if (store.state.globalLangList.length) {
          store.state.globalLangList.forEach(lang => {
            if (lang.param !== 'es_ES' && lang.param !== 'pt_PT') {
              langArr.push({
                id: lang.id,
                label: lang.name,
                param: lang.param,
                key: lang.shortName,
                select: this.i18n.locale === lang.param,
              });
            }
          });
        }
        console.log('langArr', langArr);
        return langArr;
      },
      nt() {
        return 'mbs-select-notify';
      },
      ma() {
        return 'mbs-membership';
      },
      fa() {
        return 'mbs-select-favourites';
      },
      vp() {
        return 'mbs-select-places';
      },
      mt() {
        return 'mbs-select-mytrips';
      },
      cp() {
        return 'mbs-select-change';
      },
      lh() {
        return 'mbs-select-history';
      },
      mfa() {
        return 'mbs-select-mfa';
      },
      la() {
        return 'mbs-select-email';
      },
      co() {
        return 'mbs-select-Contact';
      },
      ps() {
        return 'mbs-select-privacysettings';
      },
      ad() {
        return 'mbs-select-deletion';
      },
      ea() {
        return 'mbs-select-profile';
      },
      userDropDownList() {
        return [
          {
            key: 'nt',
            label: this.nt,
            itemImg: require('@/components/LeftAccount/images/icon-notification.svg'),
          },
          {
            key: 'ma',
            label: this.ma,
            itemImg: require('@/components/LeftAccount/images/icon-membership.svg'),
          },
          {
            key: 'fa',
            label: this.fa,
            itemImg: require('@/components/LeftAccount/images/icon-favourites.svg'),
          },
          {
            key: 'vp',
            label: this.vp,
            itemImg: require('@/components/LeftAccount/images/icon-visited-places.svg'),
          },
          {
            key: 'mt',
            label: this.mt,
            itemImg: require('@/components/LeftAccount/images/icon-booking-nav.svg'),
          },
          {
            key: 'cp',
            label: this.cp,
            itemImg: require('@/components/LeftAccount/images/icon-change-password.svg'),
          },
          {
            key: 'lh',
            label: this.lh,
            itemImg: require('@/components/LeftAccount/images/icon-phone-min.svg'),
          },
          {
            key: 'mfa',
            label: this.mfa,
            itemImg: require('@/components/LeftAccount/images/icon-mfa.svg'),
          },
          {
            key: 'la',
            label: this.la,
            itemImg: require('@/components/LeftAccount/images/icon-language.svg'),
          },
          {
            key: 'ps',
            label: this.ps,
            itemImg: require('@/components/LeftAccount/images/icon-privacy-settings.svg'),
          },
          {
            key: 'co',
            label: this.co,
            itemImg: require('@/components/LeftAccount/images/icon-contact.svg'),
          },
          {
            key: 'ad',
            label: this.ad,
            itemImg: require('@/components/LeftAccount/images/icon-deletion.svg'),
          },
          {
            key: 'ea',
            label: this.ea,
            itemImg: require('@/assets/images/eidt-icon.png'),
          },
        ];
      },
      isLogin() {
        return store.state.isLogin;
      },
      userInfo() {
        return store.state.userInfo;
      },
      firstName() {
        return store.state.userInfo?.firstName || null;
      },
      head() {
        return store.state.userInfo?.head || null;
      },
    },

    methods: {
      isTrustedUrl(url) {
        const trustedDomains = [
          'http://localhost:9099/',
          'https://visa-canada-test.dragonpass.com.cn/',
          'https://visa-canada-uat.dragonpass.com/',
          'https://visa-canada-uat2.dragonpass.com/',
          'https://visaairportcompanion.ca/',
          'https://www.visaairportcompanion.ca/',
          'https://preprod.visaairportcompanion.ca/',
        ];
        return trustedDomains.some(domain => url.startsWith(domain));
      },
      // 点击语言选项，打勾的图标改变
      languagechange(data) {
        /* eslint-disable */
        const langMap = {
          en_US: 'en',
          fr_CA: 'fr',
        };
        if (this.engDropDownList.length === 1) return;
        if (data.param === this.i18n.locale) return;
        this.i18n.locale = data.param;
        localStorage.setItem('lang', this.i18n.locale);
        const url = updateQueryString(window.location.href, 'lang', langMap[data.param]);
        // 解决在别的页面进行切换的时候会造成跳转，触发push的意义在于更新url的信息
        if (router.currentRoute.name === 'Home') {
          router.push('/');
          // location.reload();
          if (this.isTrustedUrl(url)) {
            window.location.href = url;
          }
        } else {
          // location.reload();
          if (this.isTrustedUrl(url)) {
            window.location.href = url;
          }
        }
      },
      handleLounge() {
        router.push({ path: '/lounges' });
        this.options.showLoadingModal = false;
        this.options.isShowRightWrapper = false;
      },
      handleBenefits() {
        router.push({ path: '/benefits' });
        this.options.showLoadingModal = false;
        this.options.isShowRightWrapper = false;
      },
      loginModalShow() {
        // this.$loginModal.show();
        router.push('/login');
        this.options.showLoadingModal = false;
        this.options.isShowRightWrapper = false;
      },
      handleSignup() {
        router.push('/sign-up');
        this.options.showLoadingModal = false;
        this.options.isShowRightWrapper = false;
      },
      closeMenu() {
        this.options.showLoadingModal = false;
        this.options.isShowRightWrapper = false;
      },
      show() {
        this.options.showLoadingModal = true;
        this.options.isShowRightWrapper = true;
        console.log('this.options', this.options);
      },

      hide() {
        this.options.showLoadingModal = false;
        this.options.isShowRightWrapper = false;
      },
      handleUserDropDownList(data) {
        if (data.key === 'ma') {
          router.push('/account');
        } else if (data.key === 'nt') {
          router.push('/account/notify');
        } else if (data.key === 'fa') {
          router.push('/account/favourites');
        } else if (data.key === 'cp') {
          router.push('/account/changeKey');
        } else if (data.key === 'lh') {
          router.push('/account/history');
        } else if (data.key === 'mfa') {
          router.push('/account/mfa');
        } else if (data.key === 'la') {
          router.push('/account/email');
        } else if (data.key === 'co') {
          router.push('/account/contact');
        } else if (data.key === 'vp') {
          router.push('/account/places');
        } else if (data.key === 'ea') {
          router.push('/profile');
        } else if (data.key === 'mt') {
          router.push('/account/mytrips');
        } else if (data.key === 'ad') {
          router.push('/account/deleteaccount');
        } else if (data.key === 'ps') {
          router.push('/account/privacysettings');
        }
        this.hide();
      },
      logout() {
        this.hide();
        this.$messageModal.show({
          i18nNeed: true,
          closeIcon: true,
          desc: 'mbs-ques1',
          confirmBtn: 'btn-confirm',
          cancelBtn: 'btn-cancel',
          justHide: true,
          callback: this.handleLogOut,
        });
      },
      handleLogOut() {
        store.dispatch('loginModule/logout');
        this.$router.push('/');
      },
      closeRightWrapper() {
        this.options.isShowRightWrapper = false;
        this.options.showLoadingModal = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
